<!--suppress TypeScriptUnresolvedVariable, AngularInvalidExpressionResultType -->
<div class="permission-assignments-container">
    <ng-container *ngIf="viewAssignments">
        <table mat-table *ngIf="viewAssignments.length; else noAssignments"
               [dataSource]="viewAssignments" class="assignments-table">
            <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef>
                    {{'Subject'|i18n}}
                </th>
                <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.subject|async as subject">
                        <ng-container [ngSwitch]="subject.type">
                            <ng-container *ngSwitchCase="PermissionSubjectType.USER">
                                <span *ngIf="subject.canReadUser">
                                    <app-icon name="fal-user"></app-icon>&nbsp;&nbsp;
                                    <ng-container *ngIf="reactiveSubject">
                                        <span>
                                            <a href="#"
                                               [title]="'All permissions of user {0}'|i18n:subject.user.username"
                                               (click)="onClickUsername(subject, $event)">
                                                {{subject.user.username}}
                                            </a>
                                        </span>
                                        <span>({{subject.user.first_name}} {{subject.user.last_name}})</span>
                                    </ng-container>
                                    <ng-container *ngIf="!reactiveSubject">
                                        {{subject.user.username}}
                                        ({{subject.user.first_name}} {{subject.user.last_name}})
                                    </ng-container>
                                </span>
                                <span *ngIf="!subject.canReadUser">
                                    {{'Insufficient permission to read user'|i18n}}
                                </span>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
            <ng-container matColumnDef="object">
                <th mat-header-cell *matHeaderCellDef>
                    {{'Object'|i18n}}
                </th>
                <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row.object|async as object">
                        <ng-container [ngSwitch]="object.type">
                            <ng-container *ngSwitchCase="PermissionObjectType.ENTITY">
                                <span *ngIf="object.entity">
                                    <app-icon [name]="object.entity|entityIcon"></app-icon>&nbsp;&nbsp;
                                    {{object.entity.path|nicePath:false}}
                                </span>
                                <span *ngIf="!object.entity">
                                    <app-icon name="fal-network-wired"></app-icon>&nbsp;&nbsp;
                                    {{'Resources'|i18n}}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="PermissionObjectType.CONNECTOR">
                                <span *ngIf="object.connectorId">
                                    <app-icon name="fal-plug"></app-icon>&nbsp;&nbsp;
                                    {{'Connector {0}'|i18n:object.connectorId}}
                                </span>
                                <span *ngIf="!object.connectorId">
                                    <app-icon name="fal-plug"></app-icon>&nbsp;&nbsp;
                                    {{'Connectors'|i18n}}
                                </span>
                            </ng-container>
                            <ng-container *ngSwitchCase="PermissionObjectType.USER">
                                <span *ngIf="object.canReadUser && object.user">
                                    <app-icon name="fal-user"></app-icon>&nbsp;&nbsp;
                                    {{object.user.username}} ({{object.user.first_name}} {{object.user.last_name}})
                                </span>
                                <span *ngIf="object.canReadUser && !object.user">
                                    <app-icon name="fal-users"></app-icon>&nbsp;&nbsp;
                                    {{'Users'|i18n}}
                                </span>
                                <span *ngIf="!object.canReadUser">
                                    {{'Insufficient permission to read user'|i18n}}
                                </span>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
            <ng-container matColumnDef="permissions">
                <th mat-header-cell *matHeaderCellDef class="permissions-column">
                    {{'Permissions'|i18n}}
                </th>
                <td mat-cell *matCellDef="let row">
                    <div *appVar="!readOnly && row.canEditPermissions as canEditPermissions"
                         fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
                        <ng-container *ngIf="row.permissionSettings|async as permissionSettings">
                            <app-permission-list [readOnly]="!canEditPermissions"
                                                 [settings]="permissionSettings"
                                                 [permissions]="row.permissions"
                                                 (permissionsChange)="onUpdatePermissions(row, $event)">
                            </app-permission-list>
                            <div fxLayout="row" fxLayoutGap="0.4rem">
                                <button *ngIf="canEditPermissions && row.permissions.length"
                                        mat-icon-button color="primary" class="perm-operation-button"
                                        (click)="onClickRemovePermissions(row)"
                                        [title]="'Remove all permissions'|i18n">
                                    <app-icon name="fal-times-circle"></app-icon>
                                </button>
                                <button *ngIf="canEditPermissions"
                                        mat-icon-button color="warn" class="perm-operation-button"
                                        (click)="onClickRemoveAssignment(row)"
                                        [title]="'Delete permission assignment'|i18n">
                                    <app-icon name="fal-trash-alt"></app-icon>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="assignmentsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: assignmentsColumns;" class="assignments-row"></tr>
        </table>
    </ng-container>
</div>

<ng-template #deleteAssignment let-data>
    <h1 mat-dialog-title>{{'Delete permission assignment'|i18n}}</h1>
    <div *ngIf="mkAssignmentRemovalHint(data.assignment)|async as hint"
         mat-dialog-content fxLayout="column">
        <span *ngIf="hint[0] && hint[1]">
            {{'Are you sure you want to delete permissions for {0} on {1}?'|i18n:hint[0]:hint[1]}}
        </span>
        <span *ngIf="!hint[0] || !hint[1]">
            {{'Are you sure you want to delete the selected permission assignment?'|i18n}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #noAssignments>
    <div fxLayout="row" fxLayoutAlign="center">
        <span>{{'No permission assignments'|i18n}}</span>
    </div>
</ng-template>
